import axios from '/node_modules/axios';
import { useStore } from 'vuex';
import store from '../stores';

let apiBaseUrl = process.env.VUE_APP_API_BASE_URL;
let publicBaseUrl = process.env.VUE_APP_PUBLIC_BASE_URL;


export async function getStockMusicWireList() {

  //let response = await axios.get(`/custom-springs-app/public/StockMusicWireList.csv`);
  let response = await axios.get(`${publicBaseUrl}StockMusicWireList.csv`);
    let diameters = response.data.split('\n');
    return diameters;

}

export async function getStainlessWireList() {
  let response = await axios.get(`${publicBaseUrl}StockStainless302List.csv`);
  let diameters = response.data.split('\n');
  return diameters;   
}

export async function updateQuote(state) {
  
  let apiUrl = `${apiBaseUrl}/custom-springs/v1/calculate/${state.quoteId == null ? "" : state.quoteId }`;

  let data = {
    "UT": state.specs.unitType,
    "OD": state.specs.outerDiameter,
    "WD": state.specs.wireDiameter,
    "MN": state.specs.materialType,
    "OL": state.specs.overallLength,
    "SBC": state.specs.SBC,
    "ET": state.specs.endType,
    "TQ1": state.specs.TQ1,
    "TQ2": state.specs.TQ2,
    "TQ3": state.specs.TQ3,
    "TQ4": state.specs.TQ4
  };

  if (state.quoteId != null) {
    data = {...data, ...{id: state.quoteId}};
  }
  
  let quoteId = await axios.post(apiUrl, data).then((response)=> { return response.data});
  store.commit('updateQuoteId', quoteId);

  let calculatedQuotes = await getQuote(quoteId);
  // store the results of the call in the store
  let quotes = [];
  for (let x = 0; x < 4; x++) {
    let quote = {
      quantity: (parseInt(calculatedQuotes.acf['test_quantity_' + (x + 1)])),
      price: (parseFloat(calculatedQuotes.acf['quantity_' + (x + 1) + '_price_per_unit'])).toFixed(2),
      total: (parseFloat(calculatedQuotes.acf['quantity_' + (x + 1) + '_price_per_unit']) * parseFloat(calculatedQuotes.acf['test_quantity_' + (x + 1)])).toFixed(2)
    }
    quotes.push(quote);
  }
  store.commit('updateQuotes', quotes);
  store.commit('updateLeadTime', calculatedQuotes.acf['lead_time']);
}

export async function getQuote(quoteId) {
  let apiUrl = `${apiBaseUrl}/wp/v2/custom-springs/${quoteId}`;
  return await axios.get(apiUrl).then((response)=>{return response.data});
}

export async function generateQuote(specs, emailAddress) {
  let quote = {
    "UT": specs.unitType,
    "OD": specs.outerDiameter,
    "WD": specs.wireDiameter,
    "MN": specs.materialType,
    "OL": specs.overallLength,
    "SBC": specs.SBC,
    "ET": specs.endType,
    "TQ1": specs.TQ1,
    "TQ2": specs.TQ2,
    "TQ3": specs.TQ3,
    "TQ4": specs.TQ4
  };
  let data = {
    data: quote,
    email: emailAddress,
    id: store.state.quoteId
  };

  await axios.post(`${apiBaseUrl}/custom-springs/v1/generate_quote`, data).then(function (response) {
    console.log(data.id);
    console.log(response);
    // window.open('http://wbjones-r00.loc/SpringMavenPHP/quotes/' + response.data);
  });
}

export async function storeOrder(paymentNonce, data) {
  
    let response = await axios.post(`${apiBaseUrl}/custom-springs/v1/confirmed/`, {
      nonce: paymentNonce,
      amount: store.state.order.item.total,
      quantity: store.state.order.item.quantity,
      perSpring: store.state.order.item.price,
      post_id: store.quoteId,
      first_name: data.customer.firstname,
      last_name: data.customer.lastname,
      email: data.customer.email,
      phone: data.customer.phone,
      company: data.customer.company,
      shipping_address: data.shipping.address,
      shipping_state: data.shipping.state,
      shipping_zip: data.shipping.zip,
      shipping_city: data.shipping.city,
      billing_address: data.billing.address,
      billing_state: data.billing.state,
      billing_zip: data.billing.zip,
      billing_city: data.billing.city,
      post_id: store.state.quoteId,
      unitType: store.state.specs.unitType,
      outerDiameter: store.state.specs.outerDiameter,
      wireDiameter: store.state.specs.wireDiameter,
      materialType: store.state.specs.materialType,
      freeLength: store.state.specs.overallLength,
      SBC: store.state.specs.SBC,
      endType: store.state.specs.endType,
  })
  return response;
}

